// Swiper carousel library
// https://swiperjs.com/

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

// Import styles (Ensure your builder supports this or link them in head)
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const initProductsSwiper = () => {
    const swiperEl = document.querySelector('.swiper-products');
    if (!swiperEl) return;

    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    const enableLoop = slideCount > 6;

    new Swiper('.swiper-products', {
        modules: [Navigation, Pagination],
        observer: true,
        observeParents: true,
        watchSlidesProgress: true,
        loop: enableLoop,
        slidesPerView: 1.3,
        spaceBetween: 16,
        centeredSlides: false,
        breakpoints: {
            768:  { slidesPerView: 2.2, spaceBetween: 20 },
            1024: { slidesPerView: 2.8, spaceBetween: 24 },
            1280: { slidesPerView: 4.8, spaceBetween: 24 },
            1536: { slidesPerView: 5.8, spaceBetween: 24 },
            1800: { slidesPerView: 6.8, spaceBetween: 24 },
        },
        navigation: {
            nextEl: '.swiper-products-next',
            prevEl: '.swiper-products-prev',
        },
        pagination: {
            el: '.swiper-products-pagination',
            clickable: true,
            dynamicBullets: true,
        },
    });
};

const initCobotGoSwiper = () => {
    const swiperEl = document.querySelector('.swiper-cobot-go');
    if (!swiperEl) return;

    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    const enableLoop = slideCount > 6;

    new Swiper('.swiper-cobot-go', {
        modules: [Navigation, Pagination],
        observer: true,
        observeParents: true,
        watchSlidesProgress: true,
        loop: enableLoop,
        slidesPerView: 1.3,
        spaceBetween: 16,
        centeredSlides: false,
        breakpoints: {
            768:  { slidesPerView: 2.2, spaceBetween: 20 },
            1024: { slidesPerView: 2.8, spaceBetween: 24 },
            1280: { slidesPerView: 3.8, spaceBetween: 24 },
            1536: { slidesPerView: 4.8, spaceBetween: 24 },
            1800: { slidesPerView: 5.8, spaceBetween: 24 },
        },
        navigation: {
            nextEl: '.swiper-cobot-go-next',
            prevEl: '.swiper-cobot-go-prev',
        },
        pagination: {
            el: '.swiper-cobot-go-pagination',
            clickable: true,
            dynamicBullets: true,
        },
    });
};

initProductsSwiper();
initCobotGoSwiper();
